module.exports = __webpack_public_path__ + "static/media/bg 04.7df69fec.png";